import React, { useState } from 'react';
import './CaptureView.css';
import ProcessingQueues from './ProcessingQueues';
import ExceptionsAndFailures from './ExceptionsAndFailures';

interface CaptureViewProps {
  initialTab?: 'processing' | 'exceptions';
  initialQueue?: 'review' | 'error' | 'success' | 'unknown' | 'duplicate';
}

const CaptureView: React.FC<CaptureViewProps> = ({ 
  initialTab = 'processing',
  initialQueue 
}) => {
  const [activeTab, setActiveTab] = useState<'processing' | 'exceptions'>(initialTab);

  return (
    <div className="capture-view">
      <div className="capture-main-tabs">
        <button 
          className={`capture-main-tab ${activeTab === 'processing' ? 'active' : ''}`}
          onClick={() => setActiveTab('processing')}
        >
          <svg className="tab-icon" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path d="M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"/>
          </svg>
          Processing Queues
        </button>
        <button 
          className={`capture-main-tab ${activeTab === 'exceptions' ? 'active' : ''}`}
          onClick={() => setActiveTab('exceptions')}
        >
          <svg className="tab-icon" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
          </svg>
          Exceptions
        </button>
      </div>

      <div className="capture-content">
        {activeTab === 'processing' ? (
          <ProcessingQueues 
            initialQueue={
              initialQueue === 'review' || initialQueue === 'error' || initialQueue === 'success'
                ? initialQueue
                : 'review'  // Default to 'review' if initialQueue is not a valid processing queue
            } 
          />
        ) : (
          <ExceptionsAndFailures 
            initialQueue={
              initialQueue === 'duplicate' || initialQueue === 'unknown' 
                ? initialQueue as 'duplicate' | 'unknown'
                : 'duplicate'
            } 
          />
        )}
      </div>
    </div>
  );
};

export default CaptureView;